module.exports = __webpack_public_path__ + "static/media/arrows-out.de0f27b3.svg";